import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	Img,
	interpolate,
	useCurrentFrame,
} from 'remotion';

export const ExploreEditorStarterRecording20261027Composition = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={383}
			style={{
				width: 1308,
				height: 896,
			}}
		>
			<Video
				src="https://remotion.media/explore-remotion/editor-starter-source-2026-10-27-8f2cbdf7449c.mp4"
				durationInFrames={383}
				style={{
					position: 'absolute',
				}}
			/>
			{/* Restore the portaled drag preview missing from the captured pixels. */}
			{frame >= 66 && frame <= 116 ? (
				<Img
					src="https://remotion.media/explore-remotion/editor-starter-drag-preview-2026-10-27-2bd30146ec8e.png"
					style={{
						position: 'absolute',
						left: interpolate(
							frame,
							[
								66, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82,
								84, 85, 87, 88, 89, 90, 92, 93,
							],
							[
								505, 516, 520, 524, 528, 536, 544, 546, 550, 556, 560, 562, 566,
								570, 572, 576, 578, 580, 581, 583, 585, 587, 589, 601,
							],
							{easing: Easing.step1, extrapolateRight: 'clamp'},
						),
						top: 370,
						width: 128,
						height: 140,
						border: '2px solid #1d99f3',
						borderRadius: 5,
						boxSizing: 'border-box',
					}}
				/>
			) : null}
			<MacOSCursor
				cursor={interpolate(
					frame,
					[3, 13, 30, 35, 36, 37, 64, 66, 119, 147, 294, 302],
					[
						'auto',
						'pointer',
						'auto',
						'pointer',
						'ns-resize',
						'pointer',
						'grabbing',
						'auto',
						'pointer',
						'ew-resize',
						'pointer',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 55, 115, 171, 273, 336, 343],
						[2, 1.8, 2, 1.8, 2, 1.8, 2],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
							21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
							37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 63, 64, 65,
							66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81,
							82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97,
							98, 99, 100, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
							128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140,
							141, 142, 143, 144, 145, 146, 147, 148, 155, 156, 157, 158, 159,
							160, 161, 162, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184,
							185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197,
							198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210,
							211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223,
							224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236,
							237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 253,
							254, 255, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299,
							300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312,
							313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325,
							326, 327, 328, 329, 330, 331, 332, 333,
						],
						[
							'1252.1953125px 803.4140625px',
							'1232.21875px 800.921875px',
							'1196.40625px 790.8125px',
							'1133.2578125px 770.2265625px',
							'1085.015625px 755.015625px',
							'1071.9921875px 750.6953125px',
							'1043.2734375px 738.71875px',
							'1012.890625px 724.0546875px',
							'949.875px 688.875px',
							'911.890625px 667.9296875px',
							'855.4140625px 635.21875px',
							'828.4375px 619.3984375px',
							'786.0625px 596.7578125px',
							'770.3671875px 587.9609375px',
							'758.015625px 579.421875px',
							'755.1640625px 576.5078125px',
							'751.8359375px 572.6171875px',
							'749.6328125px 569.6328125px',
							'746.0546875px 565.078125px',
							'739.71875px 558.8125px',
							'730.5390625px 551.4140625px',
							'721.6328125px 545.4765625px',
							'703.75px 539.5234375px',
							'673.296875px 531.5703125px',
							'643.84375px 523.8984375px',
							'597.96875px 513.59375px',
							'592.328125px 512.1953125px',
							'585.0546875px 509.921875px',
							'585.0546875px 509.921875px',
							'580.9453125px 508.2578125px',
							'580.59375px 507.9609375px',
							'580.28125px 507.3828125px',
							'580.25px 506.7578125px',
							'579.78125px 505.09375px',
							'579.28125px 503.1328125px',
							'576.9375px 495.890625px',
							'575.3125px 490.875px',
							'574.3515625px 485.53125px',
							'573.4140625px 481.3828125px',
							'573.4140625px 481.3828125px',
							'563.546875px 471.6953125px',
							'559.453125px 469.0859375px',
							'556.6015625px 467.5390625px',
							'555.0625px 467.0234375px',
							'554.5859375px 466.9140625px',
							'554.0703125px 466.8125px',
							'553.7109375px 466.8125px',
							'553.7109375px 466.8125px',
							'554.4765625px 466.8359375px',
							'562.9609375px 467.4375px',
							'569.84375px 468.0703125px',
							'573.84375px 468.3203125px',
							'578.65625px 468.625px',
							'581.578125px 468.7265625px',
							'586.34375px 468.96875px',
							'591.4140625px 469.0625px',
							'599.703125px 469.0625px',
							'603.1640625px 469.25px',
							'606.4453125px 469.25px',
							'611.625px 469.34375px',
							'615.703125px 469.5px',
							'618.171875px 469.5px',
							'623.34375px 469.5px',
							'626.2734375px 469.5px',
							'629.2578125px 469.5px',
							'631.4453125px 469.703125px',
							'632.9453125px 469.7109375px',
							'634.328125px 469.7109375px',
							'635.53125px 469.78125px',
							'636.8515625px 469.8828125px',
							'638.703125px 469.8828125px',
							'640.296875px 469.8828125px',
							'642.140625px 469.8828125px',
							'643.9765625px 469.8828125px',
							'644.9765625px 469.8828125px',
							'646.4921875px 469.8828125px',
							'647.65625px 469.8828125px',
							'648.5px 469.8828125px',
							'648.78125px 469.8828125px',
							'648.8828125px 469.8828125px',
							'649.109375px 469.8828125px',
							'649.15625px 469.8828125px',
							'649.9921875px 469.8828125px',
							'650.1640625px 470.015625px',
							'650.3359375px 470.03125px',
							'650.3359375px 470.03125px',
							'650.2265625px 469.703125px',
							'649.4765625px 467.5625px',
							'647.2265625px 462.46875px',
							'642.765625px 456.4609375px',
							'637.0625px 447.8125px',
							'633.296875px 440.53125px',
							'629.1875px 430.2890625px',
							'627.5703125px 424.0234375px',
							'626.4375px 416.25px',
							'626.40625px 411.828125px',
							'626.1875px 408.015625px',
							'626.1171875px 404.21875px',
							'625.578125px 401.0078125px',
							'624.9453125px 397.140625px',
							'624.4375px 393.796875px',
							'624.2109375px 392.0078125px',
							'623.734375px 389.5625px',
							'623.1796875px 387.1953125px',
							'622.4765625px 385.1875px',
							'621.578125px 383.0390625px',
							'621.1796875px 382.0390625px',
							'620.875px 381.53125px',
							'619.359375px 379.78125px',
							'618.2578125px 378.8828125px',
							'617.21875px 378.2265625px',
							'616px 377.609375px',
							'615.5546875px 377.328125px',
							'614.609375px 376.6171875px',
							'613.875px 376.1796875px',
							'613.328125px 375.90625px',
							'613.328125px 375.90625px',
							'612.7265625px 375.90625px',
							'611.2265625px 375.8125px',
							'610.28125px 375.671875px',
							'610.28125px 375.671875px',
							'607.96875px 375.671875px',
							'607.453125px 375.671875px',
							'607.4375px 375.671875px',
							'607.4375px 375.671875px',
							'608.078125px 375.671875px',
							'610.1875px 376.0859375px',
							'612.109375px 376.40625px',
							'615.671875px 376.7421875px',
							'618.078125px 376.984375px',
							'620.1484375px 377.1640625px',
							'622.0546875px 377.203125px',
							'623.546875px 377.3046875px',
							'625.5625px 377.4140625px',
							'627.4921875px 377.5390625px',
							'628.875px 377.6484375px',
							'630.015625px 377.6953125px',
							'631.9140625px 377.6953125px',
							'634.8203125px 377.6953125px',
							'637.4453125px 377.9296875px',
							'638.796875px 377.9296875px',
							'640.015625px 377.9296875px',
							'641.765625px 378.078125px',
							'643.984375px 378.328125px',
							'645.9609375px 378.40625px',
							'645.9609375px 378.40625px',
							'649.0546875px 378.6171875px',
							'650.75px 378.6796875px',
							'653.96875px 378.6796875px',
							'653.96875px 378.6796875px',
							'655.0546875px 378.6796875px',
							'656.0859375px 378.75px',
							'657.296875px 378.8671875px',
							'659.5703125px 378.8671875px',
							'661.1640625px 378.8671875px',
							'661.1640625px 378.8671875px',
							'662.7109375px 378.8671875px',
							'665.0546875px 379.1171875px',
							'665.5703125px 379.1171875px',
							'666.4765625px 379.1171875px',
							'667.5703125px 379.1875px',
							'668.703125px 379.28125px',
							'670.1015625px 379.28125px',
							'671.1796875px 379.28125px',
							'671.7109375px 379.28125px',
							'673.046875px 379.28125px',
							'674.7265625px 379.28125px',
							'675.25px 379.28125px',
							'676.234375px 379.28125px',
							'677.734375px 379.28125px',
							'679.0078125px 379.28125px',
							'679.0078125px 379.28125px',
							'681.203125px 379.453125px',
							'681.203125px 379.453125px',
							'682.28125px 379.453125px',
							'682.8046875px 379.453125px',
							'685.25px 379.5234375px',
							'686.1796875px 379.65625px',
							'686.515625px 379.65625px',
							'687.3203125px 379.65625px',
							'688.25px 379.65625px',
							'689.90625px 379.8671875px',
							'690.5625px 379.890625px',
							'691.7109375px 379.890625px',
							'692.421875px 379.890625px',
							'693.1796875px 379.890625px',
							'694.1328125px 379.890625px',
							'694.84375px 379.890625px',
							'695.359375px 379.890625px',
							'695.7265625px 379.890625px',
							'696.4296875px 379.890625px',
							'696.4296875px 379.890625px',
							'697.21875px 379.890625px',
							'697.6484375px 379.890625px',
							'697.6484375px 379.890625px',
							'698.078125px 379.890625px',
							'698.3828125px 379.890625px',
							'698.4296875px 379.890625px',
							'698.4296875px 379.890625px',
							'698.5078125px 379.890625px',
							'698.7109375px 379.890625px',
							'698.7109375px 379.890625px',
							'698.7109375px 380.03125px',
							'698.4765625px 382.1015625px',
							'697.859375px 386.4765625px',
							'698.1171875px 389.203125px',
							'704.0390625px 397.8359375px',
							'749.21875px 429.875px',
							'795.375px 462.4453125px',
							'795.375px 462.4453125px',
							'896.9296875px 536.03125px',
							'932.46875px 565.9609375px',
							'969.2890625px 600.3203125px',
							'1003.6015625px 635.046875px',
							'1052.9453125px 686.0078125px',
							'1052.9453125px 686.0078125px',
							'1083.21875px 715.90625px',
							'1136.078125px 763.8125px',
							'1153.5859375px 780.171875px',
							'1162.1640625px 788.0234375px',
							'1171.1875px 795.40625px',
							'1176.4921875px 798.1796875px',
							'1179.40625px 799.0625px',
							'1183.734375px 800.4765625px',
							'1189.1796875px 802.09375px',
							'1193.90625px 803.2578125px',
							'1199.7578125px 804.3046875px',
							'1205.1953125px 804.9609375px',
							'1208.4765625px 805.6328125px',
							'1211.9375px 807.1875px',
							'1217.5625px 809.640625px',
							'1225.0625px 812.3046875px',
							'1227.75px 813.453125px',
							'1231.59375px 814.9140625px',
							'1234.328125px 816.09375px',
							'1236.8125px 817.125px',
							'1240.703125px 819.5234375px',
							'1245.9453125px 822.65625px',
							'1250.40625px 825.125px',
							'1253.9609375px 826.9375px',
							'1256.0078125px 828.0234375px',
							'1256.46875px 828.25px',
							'1258.609375px 829.9140625px',
							'1258.9296875px 830.3984375px',
							'1259.09375px 830.71875px',
							'1259.09375px 830.7890625px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
